/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions,
  uint8ArrayToBase64
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as googleProtobuf001 from '@ngx-grpc/well-known-types';
import * as comKodypayGrpcCommon002 from '../../../../com/kodypay/grpc/common/money.pb';
import * as options003 from '../../../../options/team.pb';
export enum CancelType {
  TERMINAL = 0,
  CALLBACK = 1
}
export enum PaymentResult {
  COMPLETED = 0,
  FAILED = 1,
  PROCESSING = 2,
  RECEIVED = 3,
  AUTH_INITIATED = 4
}
export enum PaymentSource {
  TERMINAL_PAYMENT = 0,
  INTEGRATED_PAYMENT = 1,
  PAYMENT_LINK = 2
}
/**
 * Message implementation for com.kodypay.grpc.paybybank.PayByBankCodeRequest
 */
export class PayByBankCodeRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.PayByBankCodeRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PayByBankCodeRequest();
    PayByBankCodeRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PayByBankCodeRequest) {
    _instance.terminalId = _instance.terminalId || '';
    _instance.reference = _instance.reference || '';
    _instance.amount = _instance.amount || undefined;
    _instance.storeId = _instance.storeId || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PayByBankCodeRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.terminalId = _reader.readString();
          break;
        case 2:
          _instance.reference = _reader.readString();
          break;
        case 3:
          _instance.amount = new comKodypayGrpcCommon002.Money();
          _reader.readMessage(
            _instance.amount,
            comKodypayGrpcCommon002.Money.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.storeId = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PayByBankCodeRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PayByBankCodeRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.terminalId) {
      _writer.writeString(1, _instance.terminalId);
    }
    if (_instance.reference) {
      _writer.writeString(2, _instance.reference);
    }
    if (_instance.amount) {
      _writer.writeMessage(
        3,
        _instance.amount as any,
        comKodypayGrpcCommon002.Money.serializeBinaryToWriter
      );
    }
    if (_instance.storeId) {
      _writer.writeString(4, _instance.storeId);
    }
  }

  private _terminalId: string;
  private _reference: string;
  private _amount?: comKodypayGrpcCommon002.Money;
  private _storeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PayByBankCodeRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PayByBankCodeRequest.AsObject>) {
    _value = _value || {};
    this.terminalId = _value.terminalId;
    this.reference = _value.reference;
    this.amount = _value.amount
      ? new comKodypayGrpcCommon002.Money(_value.amount)
      : undefined;
    this.storeId = _value.storeId;
    PayByBankCodeRequest.refineValues(this);
  }
  get terminalId(): string {
    return this._terminalId;
  }
  set terminalId(value: string) {
    this._terminalId = value;
  }
  get reference(): string {
    return this._reference;
  }
  set reference(value: string) {
    this._reference = value;
  }
  get amount(): comKodypayGrpcCommon002.Money | undefined {
    return this._amount;
  }
  set amount(value: comKodypayGrpcCommon002.Money | undefined) {
    this._amount = value;
  }
  get storeId(): string {
    return this._storeId;
  }
  set storeId(value: string) {
    this._storeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PayByBankCodeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PayByBankCodeRequest.AsObject {
    return {
      terminalId: this.terminalId,
      reference: this.reference,
      amount: this.amount ? this.amount.toObject() : undefined,
      storeId: this.storeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PayByBankCodeRequest.AsProtobufJSON {
    return {
      terminalId: this.terminalId,
      reference: this.reference,
      amount: this.amount ? this.amount.toProtobufJSON(options) : null,
      storeId: this.storeId
    };
  }
}
export module PayByBankCodeRequest {
  /**
   * Standard JavaScript object representation for PayByBankCodeRequest
   */
  export interface AsObject {
    terminalId: string;
    reference: string;
    amount?: comKodypayGrpcCommon002.Money.AsObject;
    storeId: string;
  }

  /**
   * Protobuf JSON representation for PayByBankCodeRequest
   */
  export interface AsProtobufJSON {
    terminalId: string;
    reference: string;
    amount: comKodypayGrpcCommon002.Money.AsProtobufJSON | null;
    storeId: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.PayByBankCodeResponse
 */
export class PayByBankCodeResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.PayByBankCodeResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PayByBankCodeResponse();
    PayByBankCodeResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PayByBankCodeResponse) {
    _instance.code = _instance.code || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PayByBankCodeResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.code = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PayByBankCodeResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PayByBankCodeResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.code) {
      _writer.writeString(1, _instance.code);
    }
  }

  private _code: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PayByBankCodeResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PayByBankCodeResponse.AsObject>) {
    _value = _value || {};
    this.code = _value.code;
    PayByBankCodeResponse.refineValues(this);
  }
  get code(): string {
    return this._code;
  }
  set code(value: string) {
    this._code = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PayByBankCodeResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PayByBankCodeResponse.AsObject {
    return {
      code: this.code
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PayByBankCodeResponse.AsProtobufJSON {
    return {
      code: this.code
    };
  }
}
export module PayByBankCodeResponse {
  /**
   * Standard JavaScript object representation for PayByBankCodeResponse
   */
  export interface AsObject {
    code: string;
  }

  /**
   * Protobuf JSON representation for PayByBankCodeResponse
   */
  export interface AsProtobufJSON {
    code: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.PayByBankPaymentResultRequest
 */
export class PayByBankPaymentResultRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.PayByBankPaymentResultRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PayByBankPaymentResultRequest();
    PayByBankPaymentResultRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PayByBankPaymentResultRequest) {
    _instance.payByBankCode = _instance.payByBankCode || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PayByBankPaymentResultRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.payByBankCode = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PayByBankPaymentResultRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PayByBankPaymentResultRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.payByBankCode) {
      _writer.writeString(1, _instance.payByBankCode);
    }
  }

  private _payByBankCode: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PayByBankPaymentResultRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<PayByBankPaymentResultRequest.AsObject>
  ) {
    _value = _value || {};
    this.payByBankCode = _value.payByBankCode;
    PayByBankPaymentResultRequest.refineValues(this);
  }
  get payByBankCode(): string {
    return this._payByBankCode;
  }
  set payByBankCode(value: string) {
    this._payByBankCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PayByBankPaymentResultRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PayByBankPaymentResultRequest.AsObject {
    return {
      payByBankCode: this.payByBankCode
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PayByBankPaymentResultRequest.AsProtobufJSON {
    return {
      payByBankCode: this.payByBankCode
    };
  }
}
export module PayByBankPaymentResultRequest {
  /**
   * Standard JavaScript object representation for PayByBankPaymentResultRequest
   */
  export interface AsObject {
    payByBankCode: string;
  }

  /**
   * Protobuf JSON representation for PayByBankPaymentResultRequest
   */
  export interface AsProtobufJSON {
    payByBankCode: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.PayByBankPaymentResultResponse
 */
export class PayByBankPaymentResultResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.PayByBankPaymentResultResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PayByBankPaymentResultResponse();
    PayByBankPaymentResultResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PayByBankPaymentResultResponse) {
    _instance.paymentResult = _instance.paymentResult || 0;

    _instance.reference = _instance.reference || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PayByBankPaymentResultResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.paymentId = _reader.readString();
          break;
        case 2:
          _instance.paymentResult = _reader.readEnum();
          break;
        case 3:
          _instance.paymentDateTime = _reader.readString();
          break;
        case 4:
          _instance.reference = _reader.readString();
          break;
        case 5:
          _instance.paymentStatusUpdateDateTime = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PayByBankPaymentResultResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PayByBankPaymentResultResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.paymentId !== undefined && _instance.paymentId !== null) {
      _writer.writeString(1, _instance.paymentId);
    }
    if (_instance.paymentResult) {
      _writer.writeEnum(2, _instance.paymentResult);
    }
    if (
      _instance.paymentDateTime !== undefined &&
      _instance.paymentDateTime !== null
    ) {
      _writer.writeString(3, _instance.paymentDateTime);
    }
    if (_instance.reference) {
      _writer.writeString(4, _instance.reference);
    }
    if (
      _instance.paymentStatusUpdateDateTime !== undefined &&
      _instance.paymentStatusUpdateDateTime !== null
    ) {
      _writer.writeString(5, _instance.paymentStatusUpdateDateTime);
    }
  }

  private _paymentId?: string;
  private _paymentResult: PaymentResult;
  private _paymentDateTime?: string;
  private _reference: string;
  private _paymentStatusUpdateDateTime?: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PayByBankPaymentResultResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<PayByBankPaymentResultResponse.AsObject>
  ) {
    _value = _value || {};
    this.paymentId = _value.paymentId;
    this.paymentResult = _value.paymentResult;
    this.paymentDateTime = _value.paymentDateTime;
    this.reference = _value.reference;
    this.paymentStatusUpdateDateTime = _value.paymentStatusUpdateDateTime;
    PayByBankPaymentResultResponse.refineValues(this);
  }
  get paymentId(): string | undefined {
    return this._paymentId;
  }
  set paymentId(value?: string) {
    this._paymentId = value;
  }
  get paymentResult(): PaymentResult {
    return this._paymentResult;
  }
  set paymentResult(value: PaymentResult) {
    this._paymentResult = value;
  }
  get paymentDateTime(): string | undefined {
    return this._paymentDateTime;
  }
  set paymentDateTime(value?: string) {
    this._paymentDateTime = value;
  }
  get reference(): string {
    return this._reference;
  }
  set reference(value: string) {
    this._reference = value;
  }
  get paymentStatusUpdateDateTime(): string | undefined {
    return this._paymentStatusUpdateDateTime;
  }
  set paymentStatusUpdateDateTime(value?: string) {
    this._paymentStatusUpdateDateTime = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PayByBankPaymentResultResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PayByBankPaymentResultResponse.AsObject {
    return {
      paymentId: this.paymentId,
      paymentResult: this.paymentResult,
      paymentDateTime: this.paymentDateTime,
      reference: this.reference,
      paymentStatusUpdateDateTime: this.paymentStatusUpdateDateTime
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PayByBankPaymentResultResponse.AsProtobufJSON {
    return {
      paymentId:
        this.paymentId === null || this.paymentId === undefined
          ? null
          : this.paymentId,
      paymentResult:
        PaymentResult[
          this.paymentResult === null || this.paymentResult === undefined
            ? 0
            : this.paymentResult
        ],
      paymentDateTime:
        this.paymentDateTime === null || this.paymentDateTime === undefined
          ? null
          : this.paymentDateTime,
      reference: this.reference,
      paymentStatusUpdateDateTime:
        this.paymentStatusUpdateDateTime === null ||
        this.paymentStatusUpdateDateTime === undefined
          ? null
          : this.paymentStatusUpdateDateTime
    };
  }
}
export module PayByBankPaymentResultResponse {
  /**
   * Standard JavaScript object representation for PayByBankPaymentResultResponse
   */
  export interface AsObject {
    paymentId?: string;
    paymentResult: PaymentResult;
    paymentDateTime?: string;
    reference: string;
    paymentStatusUpdateDateTime?: string;
  }

  /**
   * Protobuf JSON representation for PayByBankPaymentResultResponse
   */
  export interface AsProtobufJSON {
    paymentId: string | null;
    paymentResult: string;
    paymentDateTime: string | null;
    reference: string;
    paymentStatusUpdateDateTime: string | null;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.TerminalPayByBankPaymentResultResponse
 */
export class TerminalPayByBankPaymentResultResponse implements GrpcMessage {
  static id =
    'com.kodypay.grpc.paybybank.TerminalPayByBankPaymentResultResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TerminalPayByBankPaymentResultResponse();
    TerminalPayByBankPaymentResultResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TerminalPayByBankPaymentResultResponse) {
    _instance.paymentResult = _instance.paymentResult || 0;

    _instance.reference = _instance.reference || '';

    _instance.sortCode = _instance.sortCode || '';
    _instance.accountNumber = _instance.accountNumber || '';
    _instance.accountName = _instance.accountName || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TerminalPayByBankPaymentResultResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.paymentId = _reader.readString();
          break;
        case 2:
          _instance.paymentResult = _reader.readEnum();
          break;
        case 3:
          _instance.paymentDateTime = _reader.readString();
          break;
        case 4:
          _instance.reference = _reader.readString();
          break;
        case 5:
          _instance.paymentStatusUpdateDateTime = _reader.readString();
          break;
        case 6:
          _instance.sortCode = _reader.readString();
          break;
        case 7:
          _instance.accountNumber = _reader.readString();
          break;
        case 8:
          _instance.accountName = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    TerminalPayByBankPaymentResultResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: TerminalPayByBankPaymentResultResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.paymentId !== undefined && _instance.paymentId !== null) {
      _writer.writeString(1, _instance.paymentId);
    }
    if (_instance.paymentResult) {
      _writer.writeEnum(2, _instance.paymentResult);
    }
    if (
      _instance.paymentDateTime !== undefined &&
      _instance.paymentDateTime !== null
    ) {
      _writer.writeString(3, _instance.paymentDateTime);
    }
    if (_instance.reference) {
      _writer.writeString(4, _instance.reference);
    }
    if (
      _instance.paymentStatusUpdateDateTime !== undefined &&
      _instance.paymentStatusUpdateDateTime !== null
    ) {
      _writer.writeString(5, _instance.paymentStatusUpdateDateTime);
    }
    if (_instance.sortCode) {
      _writer.writeString(6, _instance.sortCode);
    }
    if (_instance.accountNumber) {
      _writer.writeString(7, _instance.accountNumber);
    }
    if (_instance.accountName) {
      _writer.writeString(8, _instance.accountName);
    }
  }

  private _paymentId?: string;
  private _paymentResult: PaymentResult;
  private _paymentDateTime?: string;
  private _reference: string;
  private _paymentStatusUpdateDateTime?: string;
  private _sortCode: string;
  private _accountNumber: string;
  private _accountName: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TerminalPayByBankPaymentResultResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<TerminalPayByBankPaymentResultResponse.AsObject>
  ) {
    _value = _value || {};
    this.paymentId = _value.paymentId;
    this.paymentResult = _value.paymentResult;
    this.paymentDateTime = _value.paymentDateTime;
    this.reference = _value.reference;
    this.paymentStatusUpdateDateTime = _value.paymentStatusUpdateDateTime;
    this.sortCode = _value.sortCode;
    this.accountNumber = _value.accountNumber;
    this.accountName = _value.accountName;
    TerminalPayByBankPaymentResultResponse.refineValues(this);
  }
  get paymentId(): string | undefined {
    return this._paymentId;
  }
  set paymentId(value?: string) {
    this._paymentId = value;
  }
  get paymentResult(): PaymentResult {
    return this._paymentResult;
  }
  set paymentResult(value: PaymentResult) {
    this._paymentResult = value;
  }
  get paymentDateTime(): string | undefined {
    return this._paymentDateTime;
  }
  set paymentDateTime(value?: string) {
    this._paymentDateTime = value;
  }
  get reference(): string {
    return this._reference;
  }
  set reference(value: string) {
    this._reference = value;
  }
  get paymentStatusUpdateDateTime(): string | undefined {
    return this._paymentStatusUpdateDateTime;
  }
  set paymentStatusUpdateDateTime(value?: string) {
    this._paymentStatusUpdateDateTime = value;
  }
  get sortCode(): string {
    return this._sortCode;
  }
  set sortCode(value: string) {
    this._sortCode = value;
  }
  get accountNumber(): string {
    return this._accountNumber;
  }
  set accountNumber(value: string) {
    this._accountNumber = value;
  }
  get accountName(): string {
    return this._accountName;
  }
  set accountName(value: string) {
    this._accountName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TerminalPayByBankPaymentResultResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TerminalPayByBankPaymentResultResponse.AsObject {
    return {
      paymentId: this.paymentId,
      paymentResult: this.paymentResult,
      paymentDateTime: this.paymentDateTime,
      reference: this.reference,
      paymentStatusUpdateDateTime: this.paymentStatusUpdateDateTime,
      sortCode: this.sortCode,
      accountNumber: this.accountNumber,
      accountName: this.accountName
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TerminalPayByBankPaymentResultResponse.AsProtobufJSON {
    return {
      paymentId:
        this.paymentId === null || this.paymentId === undefined
          ? null
          : this.paymentId,
      paymentResult:
        PaymentResult[
          this.paymentResult === null || this.paymentResult === undefined
            ? 0
            : this.paymentResult
        ],
      paymentDateTime:
        this.paymentDateTime === null || this.paymentDateTime === undefined
          ? null
          : this.paymentDateTime,
      reference: this.reference,
      paymentStatusUpdateDateTime:
        this.paymentStatusUpdateDateTime === null ||
        this.paymentStatusUpdateDateTime === undefined
          ? null
          : this.paymentStatusUpdateDateTime,
      sortCode: this.sortCode,
      accountNumber: this.accountNumber,
      accountName: this.accountName
    };
  }
}
export module TerminalPayByBankPaymentResultResponse {
  /**
   * Standard JavaScript object representation for TerminalPayByBankPaymentResultResponse
   */
  export interface AsObject {
    paymentId?: string;
    paymentResult: PaymentResult;
    paymentDateTime?: string;
    reference: string;
    paymentStatusUpdateDateTime?: string;
    sortCode: string;
    accountNumber: string;
    accountName: string;
  }

  /**
   * Protobuf JSON representation for TerminalPayByBankPaymentResultResponse
   */
  export interface AsProtobufJSON {
    paymentId: string | null;
    paymentResult: string;
    paymentDateTime: string | null;
    reference: string;
    paymentStatusUpdateDateTime: string | null;
    sortCode: string;
    accountNumber: string;
    accountName: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.TerminalConsentCreationRequest
 */
export class TerminalConsentCreationRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.TerminalConsentCreationRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TerminalConsentCreationRequest();
    TerminalConsentCreationRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TerminalConsentCreationRequest) {
    _instance.terminalId = _instance.terminalId || '';
    _instance.reference = _instance.reference || '';
    _instance.amount = _instance.amount || undefined;
    _instance.storeId = _instance.storeId || '';
    _instance.institutionId = _instance.institutionId || '';
    _instance.institutionCountry = _instance.institutionCountry || '';
    _instance.terminalCountry = _instance.terminalCountry || '';
    _instance.isRefundSupported = _instance.isRefundSupported || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TerminalConsentCreationRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.terminalId = _reader.readString();
          break;
        case 2:
          _instance.reference = _reader.readString();
          break;
        case 3:
          _instance.amount = new comKodypayGrpcCommon002.Money();
          _reader.readMessage(
            _instance.amount,
            comKodypayGrpcCommon002.Money.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.storeId = _reader.readString();
          break;
        case 5:
          _instance.institutionId = _reader.readString();
          break;
        case 6:
          _instance.institutionCountry = _reader.readString();
          break;
        case 7:
          _instance.terminalCountry = _reader.readString();
          break;
        case 8:
          _instance.isRefundSupported = _reader.readBool();
          break;
        case 9:
          _instance.tipAmount = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    TerminalConsentCreationRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: TerminalConsentCreationRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.terminalId) {
      _writer.writeString(1, _instance.terminalId);
    }
    if (_instance.reference) {
      _writer.writeString(2, _instance.reference);
    }
    if (_instance.amount) {
      _writer.writeMessage(
        3,
        _instance.amount as any,
        comKodypayGrpcCommon002.Money.serializeBinaryToWriter
      );
    }
    if (_instance.storeId) {
      _writer.writeString(4, _instance.storeId);
    }
    if (_instance.institutionId) {
      _writer.writeString(5, _instance.institutionId);
    }
    if (_instance.institutionCountry) {
      _writer.writeString(6, _instance.institutionCountry);
    }
    if (_instance.terminalCountry) {
      _writer.writeString(7, _instance.terminalCountry);
    }
    if (_instance.isRefundSupported) {
      _writer.writeBool(8, _instance.isRefundSupported);
    }
    if (_instance.tipAmount !== undefined && _instance.tipAmount !== null) {
      _writer.writeString(9, _instance.tipAmount);
    }
  }

  private _terminalId: string;
  private _reference: string;
  private _amount?: comKodypayGrpcCommon002.Money;
  private _storeId: string;
  private _institutionId: string;
  private _institutionCountry: string;
  private _terminalCountry: string;
  private _isRefundSupported: boolean;
  private _tipAmount?: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TerminalConsentCreationRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<TerminalConsentCreationRequest.AsObject>
  ) {
    _value = _value || {};
    this.terminalId = _value.terminalId;
    this.reference = _value.reference;
    this.amount = _value.amount
      ? new comKodypayGrpcCommon002.Money(_value.amount)
      : undefined;
    this.storeId = _value.storeId;
    this.institutionId = _value.institutionId;
    this.institutionCountry = _value.institutionCountry;
    this.terminalCountry = _value.terminalCountry;
    this.isRefundSupported = _value.isRefundSupported;
    this.tipAmount = _value.tipAmount;
    TerminalConsentCreationRequest.refineValues(this);
  }
  get terminalId(): string {
    return this._terminalId;
  }
  set terminalId(value: string) {
    this._terminalId = value;
  }
  get reference(): string {
    return this._reference;
  }
  set reference(value: string) {
    this._reference = value;
  }
  get amount(): comKodypayGrpcCommon002.Money | undefined {
    return this._amount;
  }
  set amount(value: comKodypayGrpcCommon002.Money | undefined) {
    this._amount = value;
  }
  get storeId(): string {
    return this._storeId;
  }
  set storeId(value: string) {
    this._storeId = value;
  }
  get institutionId(): string {
    return this._institutionId;
  }
  set institutionId(value: string) {
    this._institutionId = value;
  }
  get institutionCountry(): string {
    return this._institutionCountry;
  }
  set institutionCountry(value: string) {
    this._institutionCountry = value;
  }
  get terminalCountry(): string {
    return this._terminalCountry;
  }
  set terminalCountry(value: string) {
    this._terminalCountry = value;
  }
  get isRefundSupported(): boolean {
    return this._isRefundSupported;
  }
  set isRefundSupported(value: boolean) {
    this._isRefundSupported = value;
  }
  get tipAmount(): string | undefined {
    return this._tipAmount;
  }
  set tipAmount(value?: string) {
    this._tipAmount = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TerminalConsentCreationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TerminalConsentCreationRequest.AsObject {
    return {
      terminalId: this.terminalId,
      reference: this.reference,
      amount: this.amount ? this.amount.toObject() : undefined,
      storeId: this.storeId,
      institutionId: this.institutionId,
      institutionCountry: this.institutionCountry,
      terminalCountry: this.terminalCountry,
      isRefundSupported: this.isRefundSupported,
      tipAmount: this.tipAmount
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TerminalConsentCreationRequest.AsProtobufJSON {
    return {
      terminalId: this.terminalId,
      reference: this.reference,
      amount: this.amount ? this.amount.toProtobufJSON(options) : null,
      storeId: this.storeId,
      institutionId: this.institutionId,
      institutionCountry: this.institutionCountry,
      terminalCountry: this.terminalCountry,
      isRefundSupported: this.isRefundSupported,
      tipAmount:
        this.tipAmount === null || this.tipAmount === undefined
          ? null
          : this.tipAmount
    };
  }
}
export module TerminalConsentCreationRequest {
  /**
   * Standard JavaScript object representation for TerminalConsentCreationRequest
   */
  export interface AsObject {
    terminalId: string;
    reference: string;
    amount?: comKodypayGrpcCommon002.Money.AsObject;
    storeId: string;
    institutionId: string;
    institutionCountry: string;
    terminalCountry: string;
    isRefundSupported: boolean;
    tipAmount?: string;
  }

  /**
   * Protobuf JSON representation for TerminalConsentCreationRequest
   */
  export interface AsProtobufJSON {
    terminalId: string;
    reference: string;
    amount: comKodypayGrpcCommon002.Money.AsProtobufJSON | null;
    storeId: string;
    institutionId: string;
    institutionCountry: string;
    terminalCountry: string;
    isRefundSupported: boolean;
    tipAmount: string | null;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.TerminalConsentCreationResponse
 */
export class TerminalConsentCreationResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.TerminalConsentCreationResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TerminalConsentCreationResponse();
    TerminalConsentCreationResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TerminalConsentCreationResponse) {
    _instance.payByBankCode = _instance.payByBankCode || '';
    _instance.authUrl = _instance.authUrl || '';
    _instance.qrCodeUrl = _instance.qrCodeUrl || '';
    _instance.qrCodeImage = _instance.qrCodeImage || undefined;
    _instance.sortCode = _instance.sortCode || '';
    _instance.accountNumber = _instance.accountNumber || '';
    _instance.accountName = _instance.accountName || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TerminalConsentCreationResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.payByBankCode = _reader.readString();
          break;
        case 2:
          _instance.authUrl = _reader.readString();
          break;
        case 3:
          _instance.qrCodeUrl = _reader.readString();
          break;
        case 4:
          _instance.qrCodeImage = new ImageResponse();
          _reader.readMessage(
            _instance.qrCodeImage,
            ImageResponse.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.sortCode = _reader.readString();
          break;
        case 6:
          _instance.accountNumber = _reader.readString();
          break;
        case 7:
          _instance.accountName = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    TerminalConsentCreationResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: TerminalConsentCreationResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.payByBankCode) {
      _writer.writeString(1, _instance.payByBankCode);
    }
    if (_instance.authUrl) {
      _writer.writeString(2, _instance.authUrl);
    }
    if (_instance.qrCodeUrl) {
      _writer.writeString(3, _instance.qrCodeUrl);
    }
    if (_instance.qrCodeImage) {
      _writer.writeMessage(
        4,
        _instance.qrCodeImage as any,
        ImageResponse.serializeBinaryToWriter
      );
    }
    if (_instance.sortCode) {
      _writer.writeString(5, _instance.sortCode);
    }
    if (_instance.accountNumber) {
      _writer.writeString(6, _instance.accountNumber);
    }
    if (_instance.accountName) {
      _writer.writeString(7, _instance.accountName);
    }
  }

  private _payByBankCode: string;
  private _authUrl: string;
  private _qrCodeUrl: string;
  private _qrCodeImage?: ImageResponse;
  private _sortCode: string;
  private _accountNumber: string;
  private _accountName: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TerminalConsentCreationResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<TerminalConsentCreationResponse.AsObject>
  ) {
    _value = _value || {};
    this.payByBankCode = _value.payByBankCode;
    this.authUrl = _value.authUrl;
    this.qrCodeUrl = _value.qrCodeUrl;
    this.qrCodeImage = _value.qrCodeImage
      ? new ImageResponse(_value.qrCodeImage)
      : undefined;
    this.sortCode = _value.sortCode;
    this.accountNumber = _value.accountNumber;
    this.accountName = _value.accountName;
    TerminalConsentCreationResponse.refineValues(this);
  }
  get payByBankCode(): string {
    return this._payByBankCode;
  }
  set payByBankCode(value: string) {
    this._payByBankCode = value;
  }
  get authUrl(): string {
    return this._authUrl;
  }
  set authUrl(value: string) {
    this._authUrl = value;
  }
  get qrCodeUrl(): string {
    return this._qrCodeUrl;
  }
  set qrCodeUrl(value: string) {
    this._qrCodeUrl = value;
  }
  get qrCodeImage(): ImageResponse | undefined {
    return this._qrCodeImage;
  }
  set qrCodeImage(value: ImageResponse | undefined) {
    this._qrCodeImage = value;
  }
  get sortCode(): string {
    return this._sortCode;
  }
  set sortCode(value: string) {
    this._sortCode = value;
  }
  get accountNumber(): string {
    return this._accountNumber;
  }
  set accountNumber(value: string) {
    this._accountNumber = value;
  }
  get accountName(): string {
    return this._accountName;
  }
  set accountName(value: string) {
    this._accountName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TerminalConsentCreationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TerminalConsentCreationResponse.AsObject {
    return {
      payByBankCode: this.payByBankCode,
      authUrl: this.authUrl,
      qrCodeUrl: this.qrCodeUrl,
      qrCodeImage: this.qrCodeImage ? this.qrCodeImage.toObject() : undefined,
      sortCode: this.sortCode,
      accountNumber: this.accountNumber,
      accountName: this.accountName
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TerminalConsentCreationResponse.AsProtobufJSON {
    return {
      payByBankCode: this.payByBankCode,
      authUrl: this.authUrl,
      qrCodeUrl: this.qrCodeUrl,
      qrCodeImage: this.qrCodeImage
        ? this.qrCodeImage.toProtobufJSON(options)
        : null,
      sortCode: this.sortCode,
      accountNumber: this.accountNumber,
      accountName: this.accountName
    };
  }
}
export module TerminalConsentCreationResponse {
  /**
   * Standard JavaScript object representation for TerminalConsentCreationResponse
   */
  export interface AsObject {
    payByBankCode: string;
    authUrl: string;
    qrCodeUrl: string;
    qrCodeImage?: ImageResponse.AsObject;
    sortCode: string;
    accountNumber: string;
    accountName: string;
  }

  /**
   * Protobuf JSON representation for TerminalConsentCreationResponse
   */
  export interface AsProtobufJSON {
    payByBankCode: string;
    authUrl: string;
    qrCodeUrl: string;
    qrCodeImage: ImageResponse.AsProtobufJSON | null;
    sortCode: string;
    accountNumber: string;
    accountName: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.ImageResponse
 */
export class ImageResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.ImageResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ImageResponse();
    ImageResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ImageResponse) {
    _instance.imageData = _instance.imageData || new Uint8Array();
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ImageResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.imageData = _reader.readBytes();
          break;
        case 2:
          _instance.contentType = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ImageResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ImageResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.imageData && _instance.imageData.length) {
      _writer.writeBytes(1, _instance.imageData);
    }
    if (_instance.contentType !== undefined && _instance.contentType !== null) {
      _writer.writeString(2, _instance.contentType);
    }
  }

  private _imageData: Uint8Array;
  private _contentType?: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ImageResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<ImageResponse.AsObject>) {
    _value = _value || {};
    this.imageData = _value.imageData;
    this.contentType = _value.contentType;
    ImageResponse.refineValues(this);
  }
  get imageData(): Uint8Array {
    return this._imageData;
  }
  set imageData(value: Uint8Array) {
    this._imageData = value;
  }
  get contentType(): string | undefined {
    return this._contentType;
  }
  set contentType(value?: string) {
    this._contentType = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ImageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ImageResponse.AsObject {
    return {
      imageData: this.imageData ? this.imageData.subarray(0) : new Uint8Array(),
      contentType: this.contentType
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ImageResponse.AsProtobufJSON {
    return {
      imageData: this.imageData ? uint8ArrayToBase64(this.imageData) : '',
      contentType:
        this.contentType === null || this.contentType === undefined
          ? null
          : this.contentType
    };
  }
}
export module ImageResponse {
  /**
   * Standard JavaScript object representation for ImageResponse
   */
  export interface AsObject {
    imageData: Uint8Array;
    contentType?: string;
  }

  /**
   * Protobuf JSON representation for ImageResponse
   */
  export interface AsProtobufJSON {
    imageData: string;
    contentType: string | null;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.InstitutionRequest
 */
export class InstitutionRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.InstitutionRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new InstitutionRequest();
    InstitutionRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: InstitutionRequest) {}

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: InstitutionRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        default:
          _reader.skipField();
      }
    }

    InstitutionRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: InstitutionRequest,
    _writer: BinaryWriter
  ) {}

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of InstitutionRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<InstitutionRequest.AsObject>) {
    _value = _value || {};
    InstitutionRequest.refineValues(this);
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    InstitutionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): InstitutionRequest.AsObject {
    return {};
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): InstitutionRequest.AsProtobufJSON {
    return {};
  }
}
export module InstitutionRequest {
  /**
   * Standard JavaScript object representation for InstitutionRequest
   */
  export interface AsObject {}

  /**
   * Protobuf JSON representation for InstitutionRequest
   */
  export interface AsProtobufJSON {}
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.InstitutionResponse
 */
export class InstitutionResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.InstitutionResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new InstitutionResponse();
    InstitutionResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: InstitutionResponse) {
    _instance.institution = _instance.institution || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: InstitutionResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new Institution();
          _reader.readMessage(
            messageInitializer1,
            Institution.deserializeBinaryFromReader
          );
          (_instance.institution = _instance.institution || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    InstitutionResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: InstitutionResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.institution && _instance.institution.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.institution as any,
        Institution.serializeBinaryToWriter
      );
    }
  }

  private _institution?: Institution[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of InstitutionResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<InstitutionResponse.AsObject>) {
    _value = _value || {};
    this.institution = (_value.institution || []).map(m => new Institution(m));
    InstitutionResponse.refineValues(this);
  }
  get institution(): Institution[] | undefined {
    return this._institution;
  }
  set institution(value: Institution[] | undefined) {
    this._institution = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    InstitutionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): InstitutionResponse.AsObject {
    return {
      institution: (this.institution || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): InstitutionResponse.AsProtobufJSON {
    return {
      institution: (this.institution || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module InstitutionResponse {
  /**
   * Standard JavaScript object representation for InstitutionResponse
   */
  export interface AsObject {
    institution?: Institution.AsObject[];
  }

  /**
   * Protobuf JSON representation for InstitutionResponse
   */
  export interface AsProtobufJSON {
    institution: Institution.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.Institution
 */
export class Institution implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.Institution';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Institution();
    Institution.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Institution) {
    _instance.institutionId = _instance.institutionId || '';
    _instance.institutionName = _instance.institutionName || '';
    _instance.institutionLogo = _instance.institutionLogo || '';
    _instance.institutionCountry = _instance.institutionCountry || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Institution,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.institutionId = _reader.readString();
          break;
        case 2:
          _instance.institutionName = _reader.readString();
          break;
        case 3:
          _instance.institutionLogo = _reader.readString();
          break;
        case 4:
          _instance.institutionCountry = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Institution.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: Institution,
    _writer: BinaryWriter
  ) {
    if (_instance.institutionId) {
      _writer.writeString(1, _instance.institutionId);
    }
    if (_instance.institutionName) {
      _writer.writeString(2, _instance.institutionName);
    }
    if (_instance.institutionLogo) {
      _writer.writeString(3, _instance.institutionLogo);
    }
    if (_instance.institutionCountry) {
      _writer.writeString(4, _instance.institutionCountry);
    }
  }

  private _institutionId: string;
  private _institutionName: string;
  private _institutionLogo: string;
  private _institutionCountry: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Institution to deeply clone from
   */
  constructor(_value?: RecursivePartial<Institution.AsObject>) {
    _value = _value || {};
    this.institutionId = _value.institutionId;
    this.institutionName = _value.institutionName;
    this.institutionLogo = _value.institutionLogo;
    this.institutionCountry = _value.institutionCountry;
    Institution.refineValues(this);
  }
  get institutionId(): string {
    return this._institutionId;
  }
  set institutionId(value: string) {
    this._institutionId = value;
  }
  get institutionName(): string {
    return this._institutionName;
  }
  set institutionName(value: string) {
    this._institutionName = value;
  }
  get institutionLogo(): string {
    return this._institutionLogo;
  }
  set institutionLogo(value: string) {
    this._institutionLogo = value;
  }
  get institutionCountry(): string {
    return this._institutionCountry;
  }
  set institutionCountry(value: string) {
    this._institutionCountry = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Institution.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Institution.AsObject {
    return {
      institutionId: this.institutionId,
      institutionName: this.institutionName,
      institutionLogo: this.institutionLogo,
      institutionCountry: this.institutionCountry
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Institution.AsProtobufJSON {
    return {
      institutionId: this.institutionId,
      institutionName: this.institutionName,
      institutionLogo: this.institutionLogo,
      institutionCountry: this.institutionCountry
    };
  }
}
export module Institution {
  /**
   * Standard JavaScript object representation for Institution
   */
  export interface AsObject {
    institutionId: string;
    institutionName: string;
    institutionLogo: string;
    institutionCountry: string;
  }

  /**
   * Protobuf JSON representation for Institution
   */
  export interface AsProtobufJSON {
    institutionId: string;
    institutionName: string;
    institutionLogo: string;
    institutionCountry: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.SubmitPaymentAuthRequest
 */
export class SubmitPaymentAuthRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.SubmitPaymentAuthRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SubmitPaymentAuthRequest();
    SubmitPaymentAuthRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SubmitPaymentAuthRequest) {
    _instance.payByBankCode = _instance.payByBankCode || '';
    _instance.institutionId = _instance.institutionId || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SubmitPaymentAuthRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.payByBankCode = _reader.readString();
          break;
        case 2:
          _instance.institutionId = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    SubmitPaymentAuthRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SubmitPaymentAuthRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.payByBankCode) {
      _writer.writeString(1, _instance.payByBankCode);
    }
    if (_instance.institutionId) {
      _writer.writeString(2, _instance.institutionId);
    }
  }

  private _payByBankCode: string;
  private _institutionId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SubmitPaymentAuthRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SubmitPaymentAuthRequest.AsObject>) {
    _value = _value || {};
    this.payByBankCode = _value.payByBankCode;
    this.institutionId = _value.institutionId;
    SubmitPaymentAuthRequest.refineValues(this);
  }
  get payByBankCode(): string {
    return this._payByBankCode;
  }
  set payByBankCode(value: string) {
    this._payByBankCode = value;
  }
  get institutionId(): string {
    return this._institutionId;
  }
  set institutionId(value: string) {
    this._institutionId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SubmitPaymentAuthRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SubmitPaymentAuthRequest.AsObject {
    return {
      payByBankCode: this.payByBankCode,
      institutionId: this.institutionId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SubmitPaymentAuthRequest.AsProtobufJSON {
    return {
      payByBankCode: this.payByBankCode,
      institutionId: this.institutionId
    };
  }
}
export module SubmitPaymentAuthRequest {
  /**
   * Standard JavaScript object representation for SubmitPaymentAuthRequest
   */
  export interface AsObject {
    payByBankCode: string;
    institutionId: string;
  }

  /**
   * Protobuf JSON representation for SubmitPaymentAuthRequest
   */
  export interface AsProtobufJSON {
    payByBankCode: string;
    institutionId: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.SubmitPaymentAuthResponse
 */
export class SubmitPaymentAuthResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.SubmitPaymentAuthResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SubmitPaymentAuthResponse();
    SubmitPaymentAuthResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SubmitPaymentAuthResponse) {
    _instance.authUrl = _instance.authUrl || '';
    _instance.qrCodeUrl = _instance.qrCodeUrl || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SubmitPaymentAuthResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.authUrl = _reader.readString();
          break;
        case 2:
          _instance.qrCodeUrl = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    SubmitPaymentAuthResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SubmitPaymentAuthResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.authUrl) {
      _writer.writeString(1, _instance.authUrl);
    }
    if (_instance.qrCodeUrl) {
      _writer.writeString(2, _instance.qrCodeUrl);
    }
  }

  private _authUrl: string;
  private _qrCodeUrl: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SubmitPaymentAuthResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<SubmitPaymentAuthResponse.AsObject>) {
    _value = _value || {};
    this.authUrl = _value.authUrl;
    this.qrCodeUrl = _value.qrCodeUrl;
    SubmitPaymentAuthResponse.refineValues(this);
  }
  get authUrl(): string {
    return this._authUrl;
  }
  set authUrl(value: string) {
    this._authUrl = value;
  }
  get qrCodeUrl(): string {
    return this._qrCodeUrl;
  }
  set qrCodeUrl(value: string) {
    this._qrCodeUrl = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SubmitPaymentAuthResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SubmitPaymentAuthResponse.AsObject {
    return {
      authUrl: this.authUrl,
      qrCodeUrl: this.qrCodeUrl
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SubmitPaymentAuthResponse.AsProtobufJSON {
    return {
      authUrl: this.authUrl,
      qrCodeUrl: this.qrCodeUrl
    };
  }
}
export module SubmitPaymentAuthResponse {
  /**
   * Standard JavaScript object representation for SubmitPaymentAuthResponse
   */
  export interface AsObject {
    authUrl: string;
    qrCodeUrl: string;
  }

  /**
   * Protobuf JSON representation for SubmitPaymentAuthResponse
   */
  export interface AsProtobufJSON {
    authUrl: string;
    qrCodeUrl: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.StoreDataRequest
 */
export class StoreDataRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.StoreDataRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new StoreDataRequest();
    StoreDataRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: StoreDataRequest) {
    _instance.storeId = _instance.storeId || '';
    _instance.merchantReference = _instance.merchantReference || '';
    _instance.merchantBrand = _instance.merchantBrand || '';
    _instance.balanceAccountData = _instance.balanceAccountData || undefined;

    _instance.storeName = _instance.storeName || '';
    _instance.config = _instance.config || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: StoreDataRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.storeId = _reader.readString();
          break;
        case 2:
          _instance.merchantReference = _reader.readString();
          break;
        case 3:
          _instance.merchantBrand = _reader.readString();
          break;
        case 4:
          _instance.balanceAccountData = new BalanceAccountData();
          _reader.readMessage(
            _instance.balanceAccountData,
            BalanceAccountData.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.merchantMcc = _reader.readString();
          break;
        case 6:
          _instance.merchantPaymentGroup = _reader.readString();
          break;
        case 7:
          _instance.storeName = _reader.readString();
          break;
        case 8:
          _instance.config = new Config();
          _reader.readMessage(
            _instance.config,
            Config.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    StoreDataRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: StoreDataRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.storeId) {
      _writer.writeString(1, _instance.storeId);
    }
    if (_instance.merchantReference) {
      _writer.writeString(2, _instance.merchantReference);
    }
    if (_instance.merchantBrand) {
      _writer.writeString(3, _instance.merchantBrand);
    }
    if (_instance.balanceAccountData) {
      _writer.writeMessage(
        4,
        _instance.balanceAccountData as any,
        BalanceAccountData.serializeBinaryToWriter
      );
    }
    if (_instance.merchantMcc !== undefined && _instance.merchantMcc !== null) {
      _writer.writeString(5, _instance.merchantMcc);
    }
    if (
      _instance.merchantPaymentGroup !== undefined &&
      _instance.merchantPaymentGroup !== null
    ) {
      _writer.writeString(6, _instance.merchantPaymentGroup);
    }
    if (_instance.storeName) {
      _writer.writeString(7, _instance.storeName);
    }
    if (_instance.config) {
      _writer.writeMessage(
        8,
        _instance.config as any,
        Config.serializeBinaryToWriter
      );
    }
  }

  private _storeId: string;
  private _merchantReference: string;
  private _merchantBrand: string;
  private _balanceAccountData?: BalanceAccountData;
  private _merchantMcc?: string;
  private _merchantPaymentGroup?: string;
  private _storeName: string;
  private _config?: Config;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of StoreDataRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<StoreDataRequest.AsObject>) {
    _value = _value || {};
    this.storeId = _value.storeId;
    this.merchantReference = _value.merchantReference;
    this.merchantBrand = _value.merchantBrand;
    this.balanceAccountData = _value.balanceAccountData
      ? new BalanceAccountData(_value.balanceAccountData)
      : undefined;
    this.merchantMcc = _value.merchantMcc;
    this.merchantPaymentGroup = _value.merchantPaymentGroup;
    this.storeName = _value.storeName;
    this.config = _value.config ? new Config(_value.config) : undefined;
    StoreDataRequest.refineValues(this);
  }
  get storeId(): string {
    return this._storeId;
  }
  set storeId(value: string) {
    this._storeId = value;
  }
  get merchantReference(): string {
    return this._merchantReference;
  }
  set merchantReference(value: string) {
    this._merchantReference = value;
  }
  get merchantBrand(): string {
    return this._merchantBrand;
  }
  set merchantBrand(value: string) {
    this._merchantBrand = value;
  }
  get balanceAccountData(): BalanceAccountData | undefined {
    return this._balanceAccountData;
  }
  set balanceAccountData(value: BalanceAccountData | undefined) {
    this._balanceAccountData = value;
  }
  get merchantMcc(): string | undefined {
    return this._merchantMcc;
  }
  set merchantMcc(value?: string) {
    this._merchantMcc = value;
  }
  get merchantPaymentGroup(): string | undefined {
    return this._merchantPaymentGroup;
  }
  set merchantPaymentGroup(value?: string) {
    this._merchantPaymentGroup = value;
  }
  get storeName(): string {
    return this._storeName;
  }
  set storeName(value: string) {
    this._storeName = value;
  }
  get config(): Config | undefined {
    return this._config;
  }
  set config(value: Config | undefined) {
    this._config = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    StoreDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): StoreDataRequest.AsObject {
    return {
      storeId: this.storeId,
      merchantReference: this.merchantReference,
      merchantBrand: this.merchantBrand,
      balanceAccountData: this.balanceAccountData
        ? this.balanceAccountData.toObject()
        : undefined,
      merchantMcc: this.merchantMcc,
      merchantPaymentGroup: this.merchantPaymentGroup,
      storeName: this.storeName,
      config: this.config ? this.config.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): StoreDataRequest.AsProtobufJSON {
    return {
      storeId: this.storeId,
      merchantReference: this.merchantReference,
      merchantBrand: this.merchantBrand,
      balanceAccountData: this.balanceAccountData
        ? this.balanceAccountData.toProtobufJSON(options)
        : null,
      merchantMcc:
        this.merchantMcc === null || this.merchantMcc === undefined
          ? null
          : this.merchantMcc,
      merchantPaymentGroup:
        this.merchantPaymentGroup === null ||
        this.merchantPaymentGroup === undefined
          ? null
          : this.merchantPaymentGroup,
      storeName: this.storeName,
      config: this.config ? this.config.toProtobufJSON(options) : null
    };
  }
}
export module StoreDataRequest {
  /**
   * Standard JavaScript object representation for StoreDataRequest
   */
  export interface AsObject {
    storeId: string;
    merchantReference: string;
    merchantBrand: string;
    balanceAccountData?: BalanceAccountData.AsObject;
    merchantMcc?: string;
    merchantPaymentGroup?: string;
    storeName: string;
    config?: Config.AsObject;
  }

  /**
   * Protobuf JSON representation for StoreDataRequest
   */
  export interface AsProtobufJSON {
    storeId: string;
    merchantReference: string;
    merchantBrand: string;
    balanceAccountData: BalanceAccountData.AsProtobufJSON | null;
    merchantMcc: string | null;
    merchantPaymentGroup: string | null;
    storeName: string;
    config: Config.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.BalanceAccountData
 */
export class BalanceAccountData implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.BalanceAccountData';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BalanceAccountData();
    BalanceAccountData.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BalanceAccountData) {
    _instance.accountName = _instance.accountName || '';
    _instance.sortCode = _instance.sortCode || '';
    _instance.accountNumber = _instance.accountNumber || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BalanceAccountData,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.accountName = _reader.readString();
          break;
        case 2:
          _instance.sortCode = _reader.readString();
          break;
        case 3:
          _instance.accountNumber = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    BalanceAccountData.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BalanceAccountData,
    _writer: BinaryWriter
  ) {
    if (_instance.accountName) {
      _writer.writeString(1, _instance.accountName);
    }
    if (_instance.sortCode) {
      _writer.writeString(2, _instance.sortCode);
    }
    if (_instance.accountNumber) {
      _writer.writeString(3, _instance.accountNumber);
    }
  }

  private _accountName: string;
  private _sortCode: string;
  private _accountNumber: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BalanceAccountData to deeply clone from
   */
  constructor(_value?: RecursivePartial<BalanceAccountData.AsObject>) {
    _value = _value || {};
    this.accountName = _value.accountName;
    this.sortCode = _value.sortCode;
    this.accountNumber = _value.accountNumber;
    BalanceAccountData.refineValues(this);
  }
  get accountName(): string {
    return this._accountName;
  }
  set accountName(value: string) {
    this._accountName = value;
  }
  get sortCode(): string {
    return this._sortCode;
  }
  set sortCode(value: string) {
    this._sortCode = value;
  }
  get accountNumber(): string {
    return this._accountNumber;
  }
  set accountNumber(value: string) {
    this._accountNumber = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BalanceAccountData.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BalanceAccountData.AsObject {
    return {
      accountName: this.accountName,
      sortCode: this.sortCode,
      accountNumber: this.accountNumber
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BalanceAccountData.AsProtobufJSON {
    return {
      accountName: this.accountName,
      sortCode: this.sortCode,
      accountNumber: this.accountNumber
    };
  }
}
export module BalanceAccountData {
  /**
   * Standard JavaScript object representation for BalanceAccountData
   */
  export interface AsObject {
    accountName: string;
    sortCode: string;
    accountNumber: string;
  }

  /**
   * Protobuf JSON representation for BalanceAccountData
   */
  export interface AsProtobufJSON {
    accountName: string;
    sortCode: string;
    accountNumber: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.Config
 */
export class Config implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.Config';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Config();
    Config.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Config) {
    _instance.minimumAmountThreshold = _instance.minimumAmountThreshold || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Config, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.minimumAmountThreshold = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Config.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Config, _writer: BinaryWriter) {
    if (_instance.minimumAmountThreshold) {
      _writer.writeString(1, _instance.minimumAmountThreshold);
    }
  }

  private _minimumAmountThreshold: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Config to deeply clone from
   */
  constructor(_value?: RecursivePartial<Config.AsObject>) {
    _value = _value || {};
    this.minimumAmountThreshold = _value.minimumAmountThreshold;
    Config.refineValues(this);
  }
  get minimumAmountThreshold(): string {
    return this._minimumAmountThreshold;
  }
  set minimumAmountThreshold(value: string) {
    this._minimumAmountThreshold = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Config.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Config.AsObject {
    return {
      minimumAmountThreshold: this.minimumAmountThreshold
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Config.AsProtobufJSON {
    return {
      minimumAmountThreshold: this.minimumAmountThreshold
    };
  }
}
export module Config {
  /**
   * Standard JavaScript object representation for Config
   */
  export interface AsObject {
    minimumAmountThreshold: string;
  }

  /**
   * Protobuf JSON representation for Config
   */
  export interface AsProtobufJSON {
    minimumAmountThreshold: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.StoreRequest
 */
export class StoreRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.StoreRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new StoreRequest();
    StoreRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: StoreRequest) {
    _instance.storeId = _instance.storeId || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: StoreRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.storeId = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    StoreRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: StoreRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.storeId) {
      _writer.writeString(1, _instance.storeId);
    }
  }

  private _storeId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of StoreRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<StoreRequest.AsObject>) {
    _value = _value || {};
    this.storeId = _value.storeId;
    StoreRequest.refineValues(this);
  }
  get storeId(): string {
    return this._storeId;
  }
  set storeId(value: string) {
    this._storeId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    StoreRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): StoreRequest.AsObject {
    return {
      storeId: this.storeId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): StoreRequest.AsProtobufJSON {
    return {
      storeId: this.storeId
    };
  }
}
export module StoreRequest {
  /**
   * Standard JavaScript object representation for StoreRequest
   */
  export interface AsObject {
    storeId: string;
  }

  /**
   * Protobuf JSON representation for StoreRequest
   */
  export interface AsProtobufJSON {
    storeId: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.StoreResponse
 */
export class StoreResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.StoreResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new StoreResponse();
    StoreResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: StoreResponse) {
    _instance.storeId = _instance.storeId || '';
    _instance.merchantReference = _instance.merchantReference || '';
    _instance.merchantBrand = _instance.merchantBrand || '';
    _instance.balanceAccountData = _instance.balanceAccountData || undefined;
    _instance.storeName = _instance.storeName || '';
    _instance.config = _instance.config || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: StoreResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.storeId = _reader.readString();
          break;
        case 2:
          _instance.merchantReference = _reader.readString();
          break;
        case 3:
          _instance.merchantBrand = _reader.readString();
          break;
        case 4:
          _instance.balanceAccountData = new BalanceAccountData();
          _reader.readMessage(
            _instance.balanceAccountData,
            BalanceAccountData.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.storeName = _reader.readString();
          break;
        case 6:
          _instance.config = new Config();
          _reader.readMessage(
            _instance.config,
            Config.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    StoreResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: StoreResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.storeId) {
      _writer.writeString(1, _instance.storeId);
    }
    if (_instance.merchantReference) {
      _writer.writeString(2, _instance.merchantReference);
    }
    if (_instance.merchantBrand) {
      _writer.writeString(3, _instance.merchantBrand);
    }
    if (_instance.balanceAccountData) {
      _writer.writeMessage(
        4,
        _instance.balanceAccountData as any,
        BalanceAccountData.serializeBinaryToWriter
      );
    }
    if (_instance.storeName) {
      _writer.writeString(5, _instance.storeName);
    }
    if (_instance.config) {
      _writer.writeMessage(
        6,
        _instance.config as any,
        Config.serializeBinaryToWriter
      );
    }
  }

  private _storeId: string;
  private _merchantReference: string;
  private _merchantBrand: string;
  private _balanceAccountData?: BalanceAccountData;
  private _storeName: string;
  private _config?: Config;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of StoreResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<StoreResponse.AsObject>) {
    _value = _value || {};
    this.storeId = _value.storeId;
    this.merchantReference = _value.merchantReference;
    this.merchantBrand = _value.merchantBrand;
    this.balanceAccountData = _value.balanceAccountData
      ? new BalanceAccountData(_value.balanceAccountData)
      : undefined;
    this.storeName = _value.storeName;
    this.config = _value.config ? new Config(_value.config) : undefined;
    StoreResponse.refineValues(this);
  }
  get storeId(): string {
    return this._storeId;
  }
  set storeId(value: string) {
    this._storeId = value;
  }
  get merchantReference(): string {
    return this._merchantReference;
  }
  set merchantReference(value: string) {
    this._merchantReference = value;
  }
  get merchantBrand(): string {
    return this._merchantBrand;
  }
  set merchantBrand(value: string) {
    this._merchantBrand = value;
  }
  get balanceAccountData(): BalanceAccountData | undefined {
    return this._balanceAccountData;
  }
  set balanceAccountData(value: BalanceAccountData | undefined) {
    this._balanceAccountData = value;
  }
  get storeName(): string {
    return this._storeName;
  }
  set storeName(value: string) {
    this._storeName = value;
  }
  get config(): Config | undefined {
    return this._config;
  }
  set config(value: Config | undefined) {
    this._config = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    StoreResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): StoreResponse.AsObject {
    return {
      storeId: this.storeId,
      merchantReference: this.merchantReference,
      merchantBrand: this.merchantBrand,
      balanceAccountData: this.balanceAccountData
        ? this.balanceAccountData.toObject()
        : undefined,
      storeName: this.storeName,
      config: this.config ? this.config.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): StoreResponse.AsProtobufJSON {
    return {
      storeId: this.storeId,
      merchantReference: this.merchantReference,
      merchantBrand: this.merchantBrand,
      balanceAccountData: this.balanceAccountData
        ? this.balanceAccountData.toProtobufJSON(options)
        : null,
      storeName: this.storeName,
      config: this.config ? this.config.toProtobufJSON(options) : null
    };
  }
}
export module StoreResponse {
  /**
   * Standard JavaScript object representation for StoreResponse
   */
  export interface AsObject {
    storeId: string;
    merchantReference: string;
    merchantBrand: string;
    balanceAccountData?: BalanceAccountData.AsObject;
    storeName: string;
    config?: Config.AsObject;
  }

  /**
   * Protobuf JSON representation for StoreResponse
   */
  export interface AsProtobufJSON {
    storeId: string;
    merchantReference: string;
    merchantBrand: string;
    balanceAccountData: BalanceAccountData.AsProtobufJSON | null;
    storeName: string;
    config: Config.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.CancelPaymentRequest
 */
export class CancelPaymentRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.CancelPaymentRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CancelPaymentRequest();
    CancelPaymentRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CancelPaymentRequest) {
    _instance.payByBankCode = _instance.payByBankCode || '';
    _instance.type = _instance.type || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CancelPaymentRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.payByBankCode = _reader.readString();
          break;
        case 2:
          _instance.type = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    CancelPaymentRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CancelPaymentRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.payByBankCode) {
      _writer.writeString(1, _instance.payByBankCode);
    }
    if (_instance.type) {
      _writer.writeEnum(2, _instance.type);
    }
  }

  private _payByBankCode: string;
  private _type: CancelType;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CancelPaymentRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CancelPaymentRequest.AsObject>) {
    _value = _value || {};
    this.payByBankCode = _value.payByBankCode;
    this.type = _value.type;
    CancelPaymentRequest.refineValues(this);
  }
  get payByBankCode(): string {
    return this._payByBankCode;
  }
  set payByBankCode(value: string) {
    this._payByBankCode = value;
  }
  get type(): CancelType {
    return this._type;
  }
  set type(value: CancelType) {
    this._type = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CancelPaymentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CancelPaymentRequest.AsObject {
    return {
      payByBankCode: this.payByBankCode,
      type: this.type
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CancelPaymentRequest.AsProtobufJSON {
    return {
      payByBankCode: this.payByBankCode,
      type:
        CancelType[
          this.type === null || this.type === undefined ? 0 : this.type
        ]
    };
  }
}
export module CancelPaymentRequest {
  /**
   * Standard JavaScript object representation for CancelPaymentRequest
   */
  export interface AsObject {
    payByBankCode: string;
    type: CancelType;
  }

  /**
   * Protobuf JSON representation for CancelPaymentRequest
   */
  export interface AsProtobufJSON {
    payByBankCode: string;
    type: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.CancelPaymentResponse
 */
export class CancelPaymentResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.CancelPaymentResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CancelPaymentResponse();
    CancelPaymentResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CancelPaymentResponse) {
    _instance.status = _instance.status || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CancelPaymentResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.status = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CancelPaymentResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CancelPaymentResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.status) {
      _writer.writeString(1, _instance.status);
    }
  }

  private _status: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CancelPaymentResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<CancelPaymentResponse.AsObject>) {
    _value = _value || {};
    this.status = _value.status;
    CancelPaymentResponse.refineValues(this);
  }
  get status(): string {
    return this._status;
  }
  set status(value: string) {
    this._status = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CancelPaymentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CancelPaymentResponse.AsObject {
    return {
      status: this.status
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CancelPaymentResponse.AsProtobufJSON {
    return {
      status: this.status
    };
  }
}
export module CancelPaymentResponse {
  /**
   * Standard JavaScript object representation for CancelPaymentResponse
   */
  export interface AsObject {
    status: string;
  }

  /**
   * Protobuf JSON representation for CancelPaymentResponse
   */
  export interface AsProtobufJSON {
    status: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.ProcessPaymentRequest
 */
export class ProcessPaymentRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.ProcessPaymentRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ProcessPaymentRequest();
    ProcessPaymentRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ProcessPaymentRequest) {
    _instance.payByBankCode = _instance.payByBankCode || '';
    _instance.queryParams = _instance.queryParams || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ProcessPaymentRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.payByBankCode = _reader.readString();
          break;
        case 2:
          _instance.queryParams = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ProcessPaymentRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ProcessPaymentRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.payByBankCode) {
      _writer.writeString(1, _instance.payByBankCode);
    }
    if (_instance.queryParams) {
      _writer.writeString(2, _instance.queryParams);
    }
  }

  private _payByBankCode: string;
  private _queryParams: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ProcessPaymentRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ProcessPaymentRequest.AsObject>) {
    _value = _value || {};
    this.payByBankCode = _value.payByBankCode;
    this.queryParams = _value.queryParams;
    ProcessPaymentRequest.refineValues(this);
  }
  get payByBankCode(): string {
    return this._payByBankCode;
  }
  set payByBankCode(value: string) {
    this._payByBankCode = value;
  }
  get queryParams(): string {
    return this._queryParams;
  }
  set queryParams(value: string) {
    this._queryParams = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ProcessPaymentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ProcessPaymentRequest.AsObject {
    return {
      payByBankCode: this.payByBankCode,
      queryParams: this.queryParams
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ProcessPaymentRequest.AsProtobufJSON {
    return {
      payByBankCode: this.payByBankCode,
      queryParams: this.queryParams
    };
  }
}
export module ProcessPaymentRequest {
  /**
   * Standard JavaScript object representation for ProcessPaymentRequest
   */
  export interface AsObject {
    payByBankCode: string;
    queryParams: string;
  }

  /**
   * Protobuf JSON representation for ProcessPaymentRequest
   */
  export interface AsProtobufJSON {
    payByBankCode: string;
    queryParams: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.ProcessPaymentResponse
 */
export class ProcessPaymentResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.ProcessPaymentResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ProcessPaymentResponse();
    ProcessPaymentResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ProcessPaymentResponse) {
    _instance.paymentResult = _instance.paymentResult || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ProcessPaymentResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.paymentId = _reader.readString();
          break;
        case 2:
          _instance.paymentDateTime = _reader.readString();
          break;
        case 3:
          _instance.paymentResult = _reader.readEnum();
          break;
        default:
          _reader.skipField();
      }
    }

    ProcessPaymentResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ProcessPaymentResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.paymentId !== undefined && _instance.paymentId !== null) {
      _writer.writeString(1, _instance.paymentId);
    }
    if (
      _instance.paymentDateTime !== undefined &&
      _instance.paymentDateTime !== null
    ) {
      _writer.writeString(2, _instance.paymentDateTime);
    }
    if (_instance.paymentResult) {
      _writer.writeEnum(3, _instance.paymentResult);
    }
  }

  private _paymentId?: string;
  private _paymentDateTime?: string;
  private _paymentResult: PaymentResult;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ProcessPaymentResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<ProcessPaymentResponse.AsObject>) {
    _value = _value || {};
    this.paymentId = _value.paymentId;
    this.paymentDateTime = _value.paymentDateTime;
    this.paymentResult = _value.paymentResult;
    ProcessPaymentResponse.refineValues(this);
  }
  get paymentId(): string | undefined {
    return this._paymentId;
  }
  set paymentId(value?: string) {
    this._paymentId = value;
  }
  get paymentDateTime(): string | undefined {
    return this._paymentDateTime;
  }
  set paymentDateTime(value?: string) {
    this._paymentDateTime = value;
  }
  get paymentResult(): PaymentResult {
    return this._paymentResult;
  }
  set paymentResult(value: PaymentResult) {
    this._paymentResult = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ProcessPaymentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ProcessPaymentResponse.AsObject {
    return {
      paymentId: this.paymentId,
      paymentDateTime: this.paymentDateTime,
      paymentResult: this.paymentResult
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ProcessPaymentResponse.AsProtobufJSON {
    return {
      paymentId:
        this.paymentId === null || this.paymentId === undefined
          ? null
          : this.paymentId,
      paymentDateTime:
        this.paymentDateTime === null || this.paymentDateTime === undefined
          ? null
          : this.paymentDateTime,
      paymentResult:
        PaymentResult[
          this.paymentResult === null || this.paymentResult === undefined
            ? 0
            : this.paymentResult
        ]
    };
  }
}
export module ProcessPaymentResponse {
  /**
   * Standard JavaScript object representation for ProcessPaymentResponse
   */
  export interface AsObject {
    paymentId?: string;
    paymentDateTime?: string;
    paymentResult: PaymentResult;
  }

  /**
   * Protobuf JSON representation for ProcessPaymentResponse
   */
  export interface AsProtobufJSON {
    paymentId: string | null;
    paymentDateTime: string | null;
    paymentResult: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.GetPaymentDetailsRequest
 */
export class GetPaymentDetailsRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.GetPaymentDetailsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPaymentDetailsRequest();
    GetPaymentDetailsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPaymentDetailsRequest) {
    _instance.payByBankCode = _instance.payByBankCode || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPaymentDetailsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.payByBankCode = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetPaymentDetailsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPaymentDetailsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.payByBankCode) {
      _writer.writeString(1, _instance.payByBankCode);
    }
  }

  private _payByBankCode: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPaymentDetailsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPaymentDetailsRequest.AsObject>) {
    _value = _value || {};
    this.payByBankCode = _value.payByBankCode;
    GetPaymentDetailsRequest.refineValues(this);
  }
  get payByBankCode(): string {
    return this._payByBankCode;
  }
  set payByBankCode(value: string) {
    this._payByBankCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPaymentDetailsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPaymentDetailsRequest.AsObject {
    return {
      payByBankCode: this.payByBankCode
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPaymentDetailsRequest.AsProtobufJSON {
    return {
      payByBankCode: this.payByBankCode
    };
  }
}
export module GetPaymentDetailsRequest {
  /**
   * Standard JavaScript object representation for GetPaymentDetailsRequest
   */
  export interface AsObject {
    payByBankCode: string;
  }

  /**
   * Protobuf JSON representation for GetPaymentDetailsRequest
   */
  export interface AsProtobufJSON {
    payByBankCode: string;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.GetPaymentDetailsResponse
 */
export class GetPaymentDetailsResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.GetPaymentDetailsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPaymentDetailsResponse();
    GetPaymentDetailsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPaymentDetailsResponse) {
    _instance.amount = _instance.amount || undefined;
    _instance.institutionId = _instance.institutionId || '';
    _instance.reference = _instance.reference || '';
    _instance.storeName = _instance.storeName || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPaymentDetailsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.amount = new comKodypayGrpcCommon002.Money();
          _reader.readMessage(
            _instance.amount,
            comKodypayGrpcCommon002.Money.deserializeBinaryFromReader
          );
          break;
        case 2:
          _instance.institutionId = _reader.readString();
          break;
        case 3:
          _instance.reference = _reader.readString();
          break;
        case 4:
          _instance.storeName = _reader.readString();
          break;
        case 5:
          _instance.description = _reader.readString();
          break;
        case 7:
          _instance.returnUrl = _reader.readString();
          break;
        case 8:
          _instance.autoRedirect = _reader.readBool();
          break;
        case 9:
          _instance.isWebFlow = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    GetPaymentDetailsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPaymentDetailsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.amount) {
      _writer.writeMessage(
        1,
        _instance.amount as any,
        comKodypayGrpcCommon002.Money.serializeBinaryToWriter
      );
    }
    if (_instance.institutionId) {
      _writer.writeString(2, _instance.institutionId);
    }
    if (_instance.reference) {
      _writer.writeString(3, _instance.reference);
    }
    if (_instance.storeName) {
      _writer.writeString(4, _instance.storeName);
    }
    if (_instance.description !== undefined && _instance.description !== null) {
      _writer.writeString(5, _instance.description);
    }
    if (_instance.returnUrl !== undefined && _instance.returnUrl !== null) {
      _writer.writeString(7, _instance.returnUrl);
    }
    if (
      _instance.autoRedirect !== undefined &&
      _instance.autoRedirect !== null
    ) {
      _writer.writeBool(8, _instance.autoRedirect);
    }
    if (_instance.isWebFlow !== undefined && _instance.isWebFlow !== null) {
      _writer.writeBool(9, _instance.isWebFlow);
    }
  }

  private _amount?: comKodypayGrpcCommon002.Money;
  private _institutionId: string;
  private _reference: string;
  private _storeName: string;
  private _description?: string;
  private _returnUrl?: string;
  private _autoRedirect?: boolean;
  private _isWebFlow?: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPaymentDetailsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPaymentDetailsResponse.AsObject>) {
    _value = _value || {};
    this.amount = _value.amount
      ? new comKodypayGrpcCommon002.Money(_value.amount)
      : undefined;
    this.institutionId = _value.institutionId;
    this.reference = _value.reference;
    this.storeName = _value.storeName;
    this.description = _value.description;
    this.returnUrl = _value.returnUrl;
    this.autoRedirect = _value.autoRedirect;
    this.isWebFlow = _value.isWebFlow;
    GetPaymentDetailsResponse.refineValues(this);
  }
  get amount(): comKodypayGrpcCommon002.Money | undefined {
    return this._amount;
  }
  set amount(value: comKodypayGrpcCommon002.Money | undefined) {
    this._amount = value;
  }
  get institutionId(): string {
    return this._institutionId;
  }
  set institutionId(value: string) {
    this._institutionId = value;
  }
  get reference(): string {
    return this._reference;
  }
  set reference(value: string) {
    this._reference = value;
  }
  get storeName(): string {
    return this._storeName;
  }
  set storeName(value: string) {
    this._storeName = value;
  }
  get description(): string | undefined {
    return this._description;
  }
  set description(value?: string) {
    this._description = value;
  }
  get returnUrl(): string | undefined {
    return this._returnUrl;
  }
  set returnUrl(value?: string) {
    this._returnUrl = value;
  }
  get autoRedirect(): boolean | undefined {
    return this._autoRedirect;
  }
  set autoRedirect(value?: boolean) {
    this._autoRedirect = value;
  }
  get isWebFlow(): boolean | undefined {
    return this._isWebFlow;
  }
  set isWebFlow(value?: boolean) {
    this._isWebFlow = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPaymentDetailsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPaymentDetailsResponse.AsObject {
    return {
      amount: this.amount ? this.amount.toObject() : undefined,
      institutionId: this.institutionId,
      reference: this.reference,
      storeName: this.storeName,
      description: this.description,
      returnUrl: this.returnUrl,
      autoRedirect: this.autoRedirect,
      isWebFlow: this.isWebFlow
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPaymentDetailsResponse.AsProtobufJSON {
    return {
      amount: this.amount ? this.amount.toProtobufJSON(options) : null,
      institutionId: this.institutionId,
      reference: this.reference,
      storeName: this.storeName,
      description:
        this.description === null || this.description === undefined
          ? null
          : this.description,
      returnUrl:
        this.returnUrl === null || this.returnUrl === undefined
          ? null
          : this.returnUrl,
      autoRedirect: this.autoRedirect === undefined ? null : this.autoRedirect,
      isWebFlow: this.isWebFlow === undefined ? null : this.isWebFlow
    };
  }
}
export module GetPaymentDetailsResponse {
  /**
   * Standard JavaScript object representation for GetPaymentDetailsResponse
   */
  export interface AsObject {
    amount?: comKodypayGrpcCommon002.Money.AsObject;
    institutionId: string;
    reference: string;
    storeName: string;
    description?: string;
    returnUrl?: string;
    autoRedirect?: boolean;
    isWebFlow?: boolean;
  }

  /**
   * Protobuf JSON representation for GetPaymentDetailsResponse
   */
  export interface AsProtobufJSON {
    amount: comKodypayGrpcCommon002.Money.AsProtobufJSON | null;
    institutionId: string;
    reference: string;
    storeName: string;
    description: string | null;
    returnUrl: string | null;
    autoRedirect: boolean | null;
    isWebFlow: boolean | null;
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.AuthCreationRequest
 */
export class AuthCreationRequest implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.AuthCreationRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AuthCreationRequest();
    AuthCreationRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AuthCreationRequest) {
    _instance.paymentSourceId = _instance.paymentSourceId || '';
    _instance.reference = _instance.reference || '';
    _instance.amount = _instance.amount || undefined;
    _instance.storeId = _instance.storeId || '';

    _instance.institutionId = _instance.institutionId || '';
    _instance.institutionCountry = _instance.institutionCountry || '';

    _instance.paymentSource = _instance.paymentSource || 0;

    _instance.billingAddress = _instance.billingAddress || undefined;
    _instance.shippingAddress = _instance.shippingAddress || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AuthCreationRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.paymentSourceId = _reader.readString();
          break;
        case 2:
          _instance.reference = _reader.readString();
          break;
        case 3:
          _instance.amount = new comKodypayGrpcCommon002.Money();
          _reader.readMessage(
            _instance.amount,
            comKodypayGrpcCommon002.Money.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.storeId = _reader.readString();
          break;
        case 5:
          _instance.storeCountry = _reader.readString();
          break;
        case 6:
          _instance.institutionId = _reader.readString();
          break;
        case 7:
          _instance.institutionCountry = _reader.readString();
          break;
        case 8:
          _instance.description = _reader.readString();
          break;
        case 9:
          _instance.returnUrl = _reader.readString();
          break;
        case 10:
          _instance.autoRedirect = _reader.readBool();
          break;
        case 11:
          _instance.isWebFlow = _reader.readBool();
          break;
        case 12:
          _instance.paymentSource = _reader.readEnum();
          break;
        case 13:
          _instance.shopperFirstName = _reader.readString();
          break;
        case 14:
          _instance.shopperLastName = _reader.readString();
          break;
        case 15:
          _instance.shopperPhone = _reader.readString();
          break;
        case 16:
          _instance.shopperEmail = _reader.readString();
          break;
        case 17:
          _instance.billingAddress = new AuthCreationRequest.Address();
          _reader.readMessage(
            _instance.billingAddress,
            AuthCreationRequest.Address.deserializeBinaryFromReader
          );
          break;
        case 18:
          _instance.shippingAddress = new AuthCreationRequest.Address();
          _reader.readMessage(
            _instance.shippingAddress,
            AuthCreationRequest.Address.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AuthCreationRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AuthCreationRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.paymentSourceId) {
      _writer.writeString(1, _instance.paymentSourceId);
    }
    if (_instance.reference) {
      _writer.writeString(2, _instance.reference);
    }
    if (_instance.amount) {
      _writer.writeMessage(
        3,
        _instance.amount as any,
        comKodypayGrpcCommon002.Money.serializeBinaryToWriter
      );
    }
    if (_instance.storeId) {
      _writer.writeString(4, _instance.storeId);
    }
    if (
      _instance.storeCountry !== undefined &&
      _instance.storeCountry !== null
    ) {
      _writer.writeString(5, _instance.storeCountry);
    }
    if (_instance.institutionId) {
      _writer.writeString(6, _instance.institutionId);
    }
    if (_instance.institutionCountry) {
      _writer.writeString(7, _instance.institutionCountry);
    }
    if (_instance.description !== undefined && _instance.description !== null) {
      _writer.writeString(8, _instance.description);
    }
    if (_instance.returnUrl !== undefined && _instance.returnUrl !== null) {
      _writer.writeString(9, _instance.returnUrl);
    }
    if (
      _instance.autoRedirect !== undefined &&
      _instance.autoRedirect !== null
    ) {
      _writer.writeBool(10, _instance.autoRedirect);
    }
    if (_instance.isWebFlow !== undefined && _instance.isWebFlow !== null) {
      _writer.writeBool(11, _instance.isWebFlow);
    }
    if (_instance.paymentSource) {
      _writer.writeEnum(12, _instance.paymentSource);
    }
    if (
      _instance.shopperFirstName !== undefined &&
      _instance.shopperFirstName !== null
    ) {
      _writer.writeString(13, _instance.shopperFirstName);
    }
    if (
      _instance.shopperLastName !== undefined &&
      _instance.shopperLastName !== null
    ) {
      _writer.writeString(14, _instance.shopperLastName);
    }
    if (
      _instance.shopperPhone !== undefined &&
      _instance.shopperPhone !== null
    ) {
      _writer.writeString(15, _instance.shopperPhone);
    }
    if (
      _instance.shopperEmail !== undefined &&
      _instance.shopperEmail !== null
    ) {
      _writer.writeString(16, _instance.shopperEmail);
    }
    if (_instance.billingAddress) {
      _writer.writeMessage(
        17,
        _instance.billingAddress as any,
        AuthCreationRequest.Address.serializeBinaryToWriter
      );
    }
    if (_instance.shippingAddress) {
      _writer.writeMessage(
        18,
        _instance.shippingAddress as any,
        AuthCreationRequest.Address.serializeBinaryToWriter
      );
    }
  }

  private _paymentSourceId: string;
  private _reference: string;
  private _amount?: comKodypayGrpcCommon002.Money;
  private _storeId: string;
  private _storeCountry?: string;
  private _institutionId: string;
  private _institutionCountry: string;
  private _description?: string;
  private _returnUrl?: string;
  private _autoRedirect?: boolean;
  private _isWebFlow?: boolean;
  private _paymentSource: PaymentSource;
  private _shopperFirstName?: string;
  private _shopperLastName?: string;
  private _shopperPhone?: string;
  private _shopperEmail?: string;
  private _billingAddress?: AuthCreationRequest.Address;
  private _shippingAddress?: AuthCreationRequest.Address;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AuthCreationRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AuthCreationRequest.AsObject>) {
    _value = _value || {};
    this.paymentSourceId = _value.paymentSourceId;
    this.reference = _value.reference;
    this.amount = _value.amount
      ? new comKodypayGrpcCommon002.Money(_value.amount)
      : undefined;
    this.storeId = _value.storeId;
    this.storeCountry = _value.storeCountry;
    this.institutionId = _value.institutionId;
    this.institutionCountry = _value.institutionCountry;
    this.description = _value.description;
    this.returnUrl = _value.returnUrl;
    this.autoRedirect = _value.autoRedirect;
    this.isWebFlow = _value.isWebFlow;
    this.paymentSource = _value.paymentSource;
    this.shopperFirstName = _value.shopperFirstName;
    this.shopperLastName = _value.shopperLastName;
    this.shopperPhone = _value.shopperPhone;
    this.shopperEmail = _value.shopperEmail;
    this.billingAddress = _value.billingAddress
      ? new AuthCreationRequest.Address(_value.billingAddress)
      : undefined;
    this.shippingAddress = _value.shippingAddress
      ? new AuthCreationRequest.Address(_value.shippingAddress)
      : undefined;
    AuthCreationRequest.refineValues(this);
  }
  get paymentSourceId(): string {
    return this._paymentSourceId;
  }
  set paymentSourceId(value: string) {
    this._paymentSourceId = value;
  }
  get reference(): string {
    return this._reference;
  }
  set reference(value: string) {
    this._reference = value;
  }
  get amount(): comKodypayGrpcCommon002.Money | undefined {
    return this._amount;
  }
  set amount(value: comKodypayGrpcCommon002.Money | undefined) {
    this._amount = value;
  }
  get storeId(): string {
    return this._storeId;
  }
  set storeId(value: string) {
    this._storeId = value;
  }
  get storeCountry(): string | undefined {
    return this._storeCountry;
  }
  set storeCountry(value?: string) {
    this._storeCountry = value;
  }
  get institutionId(): string {
    return this._institutionId;
  }
  set institutionId(value: string) {
    this._institutionId = value;
  }
  get institutionCountry(): string {
    return this._institutionCountry;
  }
  set institutionCountry(value: string) {
    this._institutionCountry = value;
  }
  get description(): string | undefined {
    return this._description;
  }
  set description(value?: string) {
    this._description = value;
  }
  get returnUrl(): string | undefined {
    return this._returnUrl;
  }
  set returnUrl(value?: string) {
    this._returnUrl = value;
  }
  get autoRedirect(): boolean | undefined {
    return this._autoRedirect;
  }
  set autoRedirect(value?: boolean) {
    this._autoRedirect = value;
  }
  get isWebFlow(): boolean | undefined {
    return this._isWebFlow;
  }
  set isWebFlow(value?: boolean) {
    this._isWebFlow = value;
  }
  get paymentSource(): PaymentSource {
    return this._paymentSource;
  }
  set paymentSource(value: PaymentSource) {
    this._paymentSource = value;
  }
  get shopperFirstName(): string | undefined {
    return this._shopperFirstName;
  }
  set shopperFirstName(value?: string) {
    this._shopperFirstName = value;
  }
  get shopperLastName(): string | undefined {
    return this._shopperLastName;
  }
  set shopperLastName(value?: string) {
    this._shopperLastName = value;
  }
  get shopperPhone(): string | undefined {
    return this._shopperPhone;
  }
  set shopperPhone(value?: string) {
    this._shopperPhone = value;
  }
  get shopperEmail(): string | undefined {
    return this._shopperEmail;
  }
  set shopperEmail(value?: string) {
    this._shopperEmail = value;
  }
  get billingAddress(): AuthCreationRequest.Address | undefined {
    return this._billingAddress;
  }
  set billingAddress(value: AuthCreationRequest.Address | undefined) {
    this._billingAddress = value;
  }
  get shippingAddress(): AuthCreationRequest.Address | undefined {
    return this._shippingAddress;
  }
  set shippingAddress(value: AuthCreationRequest.Address | undefined) {
    this._shippingAddress = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AuthCreationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AuthCreationRequest.AsObject {
    return {
      paymentSourceId: this.paymentSourceId,
      reference: this.reference,
      amount: this.amount ? this.amount.toObject() : undefined,
      storeId: this.storeId,
      storeCountry: this.storeCountry,
      institutionId: this.institutionId,
      institutionCountry: this.institutionCountry,
      description: this.description,
      returnUrl: this.returnUrl,
      autoRedirect: this.autoRedirect,
      isWebFlow: this.isWebFlow,
      paymentSource: this.paymentSource,
      shopperFirstName: this.shopperFirstName,
      shopperLastName: this.shopperLastName,
      shopperPhone: this.shopperPhone,
      shopperEmail: this.shopperEmail,
      billingAddress: this.billingAddress
        ? this.billingAddress.toObject()
        : undefined,
      shippingAddress: this.shippingAddress
        ? this.shippingAddress.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AuthCreationRequest.AsProtobufJSON {
    return {
      paymentSourceId: this.paymentSourceId,
      reference: this.reference,
      amount: this.amount ? this.amount.toProtobufJSON(options) : null,
      storeId: this.storeId,
      storeCountry:
        this.storeCountry === null || this.storeCountry === undefined
          ? null
          : this.storeCountry,
      institutionId: this.institutionId,
      institutionCountry: this.institutionCountry,
      description:
        this.description === null || this.description === undefined
          ? null
          : this.description,
      returnUrl:
        this.returnUrl === null || this.returnUrl === undefined
          ? null
          : this.returnUrl,
      autoRedirect: this.autoRedirect === undefined ? null : this.autoRedirect,
      isWebFlow: this.isWebFlow === undefined ? null : this.isWebFlow,
      paymentSource:
        PaymentSource[
          this.paymentSource === null || this.paymentSource === undefined
            ? 0
            : this.paymentSource
        ],
      shopperFirstName:
        this.shopperFirstName === null || this.shopperFirstName === undefined
          ? null
          : this.shopperFirstName,
      shopperLastName:
        this.shopperLastName === null || this.shopperLastName === undefined
          ? null
          : this.shopperLastName,
      shopperPhone:
        this.shopperPhone === null || this.shopperPhone === undefined
          ? null
          : this.shopperPhone,
      shopperEmail:
        this.shopperEmail === null || this.shopperEmail === undefined
          ? null
          : this.shopperEmail,
      billingAddress: this.billingAddress
        ? this.billingAddress.toProtobufJSON(options)
        : null,
      shippingAddress: this.shippingAddress
        ? this.shippingAddress.toProtobufJSON(options)
        : null
    };
  }
}
export module AuthCreationRequest {
  /**
   * Standard JavaScript object representation for AuthCreationRequest
   */
  export interface AsObject {
    paymentSourceId: string;
    reference: string;
    amount?: comKodypayGrpcCommon002.Money.AsObject;
    storeId: string;
    storeCountry?: string;
    institutionId: string;
    institutionCountry: string;
    description?: string;
    returnUrl?: string;
    autoRedirect?: boolean;
    isWebFlow?: boolean;
    paymentSource: PaymentSource;
    shopperFirstName?: string;
    shopperLastName?: string;
    shopperPhone?: string;
    shopperEmail?: string;
    billingAddress?: AuthCreationRequest.Address.AsObject;
    shippingAddress?: AuthCreationRequest.Address.AsObject;
  }

  /**
   * Protobuf JSON representation for AuthCreationRequest
   */
  export interface AsProtobufJSON {
    paymentSourceId: string;
    reference: string;
    amount: comKodypayGrpcCommon002.Money.AsProtobufJSON | null;
    storeId: string;
    storeCountry: string | null;
    institutionId: string;
    institutionCountry: string;
    description: string | null;
    returnUrl: string | null;
    autoRedirect: boolean | null;
    isWebFlow: boolean | null;
    paymentSource: string;
    shopperFirstName: string | null;
    shopperLastName: string | null;
    shopperPhone: string | null;
    shopperEmail: string | null;
    billingAddress: AuthCreationRequest.Address.AsProtobufJSON | null;
    shippingAddress: AuthCreationRequest.Address.AsProtobufJSON | null;
  }

  /**
   * Message implementation for com.kodypay.grpc.paybybank.AuthCreationRequest.Address
   */
  export class Address implements GrpcMessage {
    static id = 'com.kodypay.grpc.paybybank.AuthCreationRequest.Address';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new Address();
      Address.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: Address) {
      _instance.houseNumberOrName = _instance.houseNumberOrName || '';
      _instance.street = _instance.street || '';
      _instance.city = _instance.city || '';
      _instance.postcode = _instance.postcode || '';
      _instance.country = _instance.country || '';
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(
      _instance: Address,
      _reader: BinaryReader
    ) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.houseNumberOrName = _reader.readString();
            break;
          case 2:
            _instance.street = _reader.readString();
            break;
          case 3:
            _instance.city = _reader.readString();
            break;
          case 4:
            _instance.postcode = _reader.readString();
            break;
          case 5:
            _instance.country = _reader.readString();
            break;
          default:
            _reader.skipField();
        }
      }

      Address.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(_instance: Address, _writer: BinaryWriter) {
      if (_instance.houseNumberOrName) {
        _writer.writeString(1, _instance.houseNumberOrName);
      }
      if (_instance.street) {
        _writer.writeString(2, _instance.street);
      }
      if (_instance.city) {
        _writer.writeString(3, _instance.city);
      }
      if (_instance.postcode) {
        _writer.writeString(4, _instance.postcode);
      }
      if (_instance.country) {
        _writer.writeString(5, _instance.country);
      }
    }

    private _houseNumberOrName: string;
    private _street: string;
    private _city: string;
    private _postcode: string;
    private _country: string;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of Address to deeply clone from
     */
    constructor(_value?: RecursivePartial<Address.AsObject>) {
      _value = _value || {};
      this.houseNumberOrName = _value.houseNumberOrName;
      this.street = _value.street;
      this.city = _value.city;
      this.postcode = _value.postcode;
      this.country = _value.country;
      Address.refineValues(this);
    }
    get houseNumberOrName(): string {
      return this._houseNumberOrName;
    }
    set houseNumberOrName(value: string) {
      this._houseNumberOrName = value;
    }
    get street(): string {
      return this._street;
    }
    set street(value: string) {
      this._street = value;
    }
    get city(): string {
      return this._city;
    }
    set city(value: string) {
      this._city = value;
    }
    get postcode(): string {
      return this._postcode;
    }
    set postcode(value: string) {
      this._postcode = value;
    }
    get country(): string {
      return this._country;
    }
    set country(value: string) {
      this._country = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      Address.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): Address.AsObject {
      return {
        houseNumberOrName: this.houseNumberOrName,
        street: this.street,
        city: this.city,
        postcode: this.postcode,
        country: this.country
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): Address.AsProtobufJSON {
      return {
        houseNumberOrName: this.houseNumberOrName,
        street: this.street,
        city: this.city,
        postcode: this.postcode,
        country: this.country
      };
    }
  }
  export module Address {
    /**
     * Standard JavaScript object representation for Address
     */
    export interface AsObject {
      houseNumberOrName: string;
      street: string;
      city: string;
      postcode: string;
      country: string;
    }

    /**
     * Protobuf JSON representation for Address
     */
    export interface AsProtobufJSON {
      houseNumberOrName: string;
      street: string;
      city: string;
      postcode: string;
      country: string;
    }
  }
}

/**
 * Message implementation for com.kodypay.grpc.paybybank.AuthCreationResponse
 */
export class AuthCreationResponse implements GrpcMessage {
  static id = 'com.kodypay.grpc.paybybank.AuthCreationResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AuthCreationResponse();
    AuthCreationResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AuthCreationResponse) {
    _instance.payByBankCode = _instance.payByBankCode || '';
    _instance.authUrl = _instance.authUrl || '';
    _instance.qrCodeUrl = _instance.qrCodeUrl || '';
    _instance.qrCodeImage = _instance.qrCodeImage || undefined;
    _instance.sortCode = _instance.sortCode || '';
    _instance.accountNumber = _instance.accountNumber || '';
    _instance.accountName = _instance.accountName || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AuthCreationResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.payByBankCode = _reader.readString();
          break;
        case 2:
          _instance.authUrl = _reader.readString();
          break;
        case 3:
          _instance.qrCodeUrl = _reader.readString();
          break;
        case 4:
          _instance.qrCodeImage = new ImageResponse();
          _reader.readMessage(
            _instance.qrCodeImage,
            ImageResponse.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.sortCode = _reader.readString();
          break;
        case 6:
          _instance.accountNumber = _reader.readString();
          break;
        case 7:
          _instance.accountName = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    AuthCreationResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AuthCreationResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.payByBankCode) {
      _writer.writeString(1, _instance.payByBankCode);
    }
    if (_instance.authUrl) {
      _writer.writeString(2, _instance.authUrl);
    }
    if (_instance.qrCodeUrl) {
      _writer.writeString(3, _instance.qrCodeUrl);
    }
    if (_instance.qrCodeImage) {
      _writer.writeMessage(
        4,
        _instance.qrCodeImage as any,
        ImageResponse.serializeBinaryToWriter
      );
    }
    if (_instance.sortCode) {
      _writer.writeString(5, _instance.sortCode);
    }
    if (_instance.accountNumber) {
      _writer.writeString(6, _instance.accountNumber);
    }
    if (_instance.accountName) {
      _writer.writeString(7, _instance.accountName);
    }
  }

  private _payByBankCode: string;
  private _authUrl: string;
  private _qrCodeUrl: string;
  private _qrCodeImage?: ImageResponse;
  private _sortCode: string;
  private _accountNumber: string;
  private _accountName: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AuthCreationResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AuthCreationResponse.AsObject>) {
    _value = _value || {};
    this.payByBankCode = _value.payByBankCode;
    this.authUrl = _value.authUrl;
    this.qrCodeUrl = _value.qrCodeUrl;
    this.qrCodeImage = _value.qrCodeImage
      ? new ImageResponse(_value.qrCodeImage)
      : undefined;
    this.sortCode = _value.sortCode;
    this.accountNumber = _value.accountNumber;
    this.accountName = _value.accountName;
    AuthCreationResponse.refineValues(this);
  }
  get payByBankCode(): string {
    return this._payByBankCode;
  }
  set payByBankCode(value: string) {
    this._payByBankCode = value;
  }
  get authUrl(): string {
    return this._authUrl;
  }
  set authUrl(value: string) {
    this._authUrl = value;
  }
  get qrCodeUrl(): string {
    return this._qrCodeUrl;
  }
  set qrCodeUrl(value: string) {
    this._qrCodeUrl = value;
  }
  get qrCodeImage(): ImageResponse | undefined {
    return this._qrCodeImage;
  }
  set qrCodeImage(value: ImageResponse | undefined) {
    this._qrCodeImage = value;
  }
  get sortCode(): string {
    return this._sortCode;
  }
  set sortCode(value: string) {
    this._sortCode = value;
  }
  get accountNumber(): string {
    return this._accountNumber;
  }
  set accountNumber(value: string) {
    this._accountNumber = value;
  }
  get accountName(): string {
    return this._accountName;
  }
  set accountName(value: string) {
    this._accountName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AuthCreationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AuthCreationResponse.AsObject {
    return {
      payByBankCode: this.payByBankCode,
      authUrl: this.authUrl,
      qrCodeUrl: this.qrCodeUrl,
      qrCodeImage: this.qrCodeImage ? this.qrCodeImage.toObject() : undefined,
      sortCode: this.sortCode,
      accountNumber: this.accountNumber,
      accountName: this.accountName
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AuthCreationResponse.AsProtobufJSON {
    return {
      payByBankCode: this.payByBankCode,
      authUrl: this.authUrl,
      qrCodeUrl: this.qrCodeUrl,
      qrCodeImage: this.qrCodeImage
        ? this.qrCodeImage.toProtobufJSON(options)
        : null,
      sortCode: this.sortCode,
      accountNumber: this.accountNumber,
      accountName: this.accountName
    };
  }
}
export module AuthCreationResponse {
  /**
   * Standard JavaScript object representation for AuthCreationResponse
   */
  export interface AsObject {
    payByBankCode: string;
    authUrl: string;
    qrCodeUrl: string;
    qrCodeImage?: ImageResponse.AsObject;
    sortCode: string;
    accountNumber: string;
    accountName: string;
  }

  /**
   * Protobuf JSON representation for AuthCreationResponse
   */
  export interface AsProtobufJSON {
    payByBankCode: string;
    authUrl: string;
    qrCodeUrl: string;
    qrCodeImage: ImageResponse.AsProtobufJSON | null;
    sortCode: string;
    accountNumber: string;
    accountName: string;
  }
}
